<template>
  <div class="gnb-main" :class="{ focusd: isFocusOn }" @click="enterKeyProc">
    <div @mouseover="mouseOver(-1)">
      <img
        v-if="isFocusedMenu(-1)"
        class="return_ic"
        src="@/assets/return-detail-f-ic.png"
      />
      <img v-else class="return_ic" src="@/assets/return-detail-ic.png" />
    </div>
    <div class="title-text singleline">{{ titleName }}</div>
    <template v-if="gameType == 2 || gameType == 8">
      <div class="sideMenu">
        <div
          v-for="item in listItems"
          :key="item.seqNo"
          class="menu singleline"
          :class="{
            focused: isFocusedMenu(item.seqNo),
            selected: isSelectedMenu(item.seqNo),
          }"
          @mouseover="mouseOver(item.seqNo)"
        >
          {{ item.year }}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="sideMenu" @wheel="wheelScroll">
        <div
          v-for="(item, index) in listItems.list"
          :key="`menu_${index}`"
          class="menu singleline"
          v-show="index > scrollIndex -1 && index < menuVisibleIndex + scrollIndex"
          :class="{
            focused: isFocusedMenu(item.seqNo),
            selected: isSelectedMenu(item.seqNo),
          }"
          @mouseover="mouseOver(item.seqNo)"
        >
          {{ item.name }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActiveVue: true,
      isFocusOn: false,
      focusedIndex: 0,
      selectedIndex: 0,
      leagueName : '',
      scrollIndex: 0,
      listCountValue: 11,
      menuVisibleIndex: 11
    }
  },
  props: {
    gnbFocus: Number,
  },
  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
    fousedView() {
      return this.$store.getters.focusedView;
    },
    listItems() {
      if (this.gameType == 2 || this.gameType == 8) {
        return this.$store.getters.yearList;
      } else {
        return this.$store.getters.leagueSeasonList;
      }
    },
    maxIndex() {
      if (this.gameType == 2 || this.gameType == 8) {
        return this.listItems.length;
      } else {
        return this.listItems.list.length;
      }
    },
    gameType() {
      return this.$route.params.gameTypeId;
    },
    titleName(){
      return this.listItems.title || this.leagueName
    }
  },
  watch: {
    fousedView(val, oldVal) {
      if (val == "gnb") {
        this.isFocusOn = true;
      } else {
        this.isFocusOn = false;
        this.focusedIndex = this.selectedIndex;
      }

      if (window.innerWidth <= 1280) {
        if (this.focusedIndex > 10) this.scrollIndex = this.focusedIndex - 9;
      } else {
        if (this.focusedIndex > 10) this.scrollIndex = this.focusedIndex - 10;
      }
    },
    keyInput(val, oldVal) {
      if (this.isActiveVue && val.focusView == "gnb") {
        switch (val.key) {
          case "ArrowUp":
            this.upKeyProc(val);
            break;
          case "ArrowDown":
            this.downKeyProc(val);
            break;
          case "ArrowRight":
            this.rightKeyProc(val);
            break;
          case "Enter":
            this.enterKeyProc(val);
            break;
          case "Backspace":
            this.backKeyProc(val);
            break;
        }
      }
    },
  },
  methods: {
    upKeyProc(keyInput) {
      console.log("upKey focussedIndex :: ", this.focusedIndex, " /// selected :: ", this.selectedIndex, " /// scroll :: ", this.scrollIndex);
      if (this.focusedIndex > -1) this.focusedIndex -= 1;

      if (this.scrollIndex > 0) this.scrollIndex--;
    },
    downKeyProc(keyInput) {
      console.log("downKey focussedIndex :: ", this.focusedIndex, " /// selected :: ", this.selectedIndex, " /// scroll :: ", this.scrollIndex);
      if (this.focusedIndex < this.maxIndex - 1) this.focusedIndex += 1;
      if (window.innerWidth <= 1280) {
        if (this.focusedIndex > 9 && this.scrollIndex < this.maxIndex - 10) this.scrollIndex++;
      } else {
        if (this.focusedIndex > 10 && this.scrollIndex < this.maxIndex - 10) this.scrollIndex++;
      }
    },
    rightKeyProc(keyInput) {
      this.focusedIndex = this.selectedIndex;
      this.$store.commit("SET_FOCUSED_VIEW", "default");
    },
    enterKeyProc(keyInput) {
      console.log("focussedIndex :: ", this.focusedIndex, " /// selected :: ", this.selectedIndex, " /// scroll :: ", this.scrollIndex);
      if (this.focusedIndex == -1) {
        this.$router.go(-1);
      } else if (this.focusedIndex === this.selectedIndex) {
        this.$store.commit("SET_FOCUSED_VIEW", "default");
      } else {
        this.selectedIndex = this.focusedIndex;
        // 라우터 이동
        if (this.gameType == 2 || this.gameType == 8) {
          this.$route.params.year = this.listItems[this.focusedIndex].year;
          this.$router.replace({
            name: "league2nd-year",
            params: {
              name: this.titleName,
              leagueId: this.listItems.leagueId || this.$route.params.leagueId,
              gameTypeId: this.gameType,
              selectedIndex: this.selectedIndex,
              t: new Date().getTime(),
            },
          });
        } else {
          this.$router.replace({
            name: "league2nd-season",
            params: {
              gameTypeId: this.listItems.gameType,
              leagueId: this.listItems.leagueId,
              seasonId: this.listItems.list[this.focusedIndex].id,
              name: this.listItems.title,
              selectedIndex: this.selectedIndex,
              t: new Date().getTime(),
            },
          });
        }
        this.$store.commit("SET_FOCUSED_VIEW", "default");
      }
    },
    backKeyProc(keyInput) {
      this.$router.go(-1);
    },
    isFocusedMenu(MenuIndex) {
      return this.isFocusOn && MenuIndex == this.focusedIndex;
    },
    isSelectedMenu(index) {
      return index == this.selectedIndex;
    },
    mouseOver(index) {
      if (index) {
        this.focusedIndex = index;
      }
      this.$store.commit("SET_FOCUSED_VIEW", "gnb");
    },
    mouseOut(index) {
      this.$store.commit("SET_FOCUSED_VIEW", "default");
    },
    wheelScroll(e) {
      if (e.deltaY < 0) {
        // 목록을 위로 올릴 경우
        if (this.scrollIndex > 0) this.scrollIndex--
      } else {
        // 목록을 아래로 내릴 경우
        if (this.scrollIndex < this.maxIndex - 12) this.scrollIndex++
      }
    }
  },
  mounted(){
    const index = this.$route.params.selectedIndex;
    if(index){
      this.selectedIndex = index;
      this.focusedIndex = index;

      if (window.innerWidth <= 1280) {
        this.menuVisibleIndex = 10;
        if (this.focusedIndex > 10) this.scrollIndex = this.focusedIndex - 9;
      } else {
        this.menuVisibleIndex = 11;
        if (this.focusedIndex > 10) this.scrollIndex = this.focusedIndex - 10;
      }
    }
    const leagueName = this.$route.params.name;
    if(leagueName){
      this.leagueName = leagueName;
    }
  },
  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
  beforeDestroy() {
    // this.selectedIndex = 0;
  },
};
</script>

<style scoped>
.gnb-main {
  position: absolute;
  z-index: 10;
  left: 0;
  top: 0;
  width: 400px;
  height: 1080px;
  background-color: rgba(30, 30, 30, 0.95);
  transition: width 0.2s;
}
.return_ic {
  position: absolute;
  width: 64px;
  height: 64px;
  left: 41px;
  top: 54px;
}
.title-text {
  margin-top: 188px;
  margin-left: 44px;
  margin-bottom: 25px;
  font-size: 40px;
  font-weight: bold;
  line-height: 1.4;
  color: #eeeeee;
}
.sideMenu {
  width: 100%;
  height: 800px;
}
.menu {
  height: 72px;
  padding-left: 44px;
  font-size: 28px;
  line-height: 2.57;
  color: #888888;
}
.menu.focused {
  background-color: rgba(62, 62, 62, 0.95);
  border-top: solid 2px #eeeeee;
  border-bottom: solid 2px #eeeeee;
  margin-top: -2px;
  margin-bottom: -2px;
}
.menu.selected {
  color: #eeeeee;
}

@media all and (min-width:0px) and (max-width:1280px){ 
  .gnb-main {
    position: absolute;
    z-index: 10;
    left: 0;
    top: 0;
    width: 280px;
    height: 100vh;
    background-color: rgba(30, 30, 30, 0.95);
    transition: width 0.2s;
  }
  .return_ic {
    position: absolute;
    width: 48px;
    height: 48px;
    left: 32px;
    top: 32px;
  }

  .title-text {
    margin-top: 128px;
    margin-left: 32px;
    margin-bottom: 24px;
    font-size: 26px;
    font-weight: bold;
    line-height: 1;
    color: #eeeeee;
  }
  .sideMenu {
    width: 100%;
    height: 541px;
  }
  .menu {
    height: 56px;
    padding: 18px 32px;
    font-size: 20px;
    line-height: 1;
    color: #888888;
    border-top: solid 1px transparent;
    border-bottom: solid 1px transparent;
  }
  .menu.focused {
    background-color: rgba(62, 62, 62, 0.95);
    border-top: solid 1px #eeeeee;
    border-bottom: solid 1px #eeeeee;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .menu.selected {
    color: #eeeeee;
  }
}
</style>